<template>
  <iframe
    class="video-player"
    :src="src + (autoplay ? '&autoplay=1&autopause=0&loop=1' : '')"
    :width="width"
    :height="height"
    allow="autoplay; fullscreen; picture-in-picture"
    allowfullscreen
    :style="aspectRatio"
    loading="lazy"
    title="Video Player"
  ></iframe>
</template>

<script>
export default {
  props: {
    video: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 1000,
    },
    height: {
      type: Number,
      default: 562.5,
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    aspectRatio() {
      return {
        '--aspect-ratio': this.height / this.width,
      };
    },
    src() {
      if (this.video.startsWith('https://vimeo.com')) {
        const id = this.video.split('/')[3];
        return `https://player.vimeo.com/video/${id}?color=7BA893&title=0&byline=0&portrait=0`;
      }
      return this.video;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './VideoPlayer.scss';
</style>
